import { AbstractControl } from '@angular/forms';

export const isPasswordMatch = () => {
  return (form: AbstractControl) => {
    const password = form.get('password')?.value;
    const confirm_password = form.get('confirm_password')?.value;
    return password === confirm_password ? null : { notMatch: true };
  };
};
